import { default as NextLink } from 'next/link';
import { forwardRef, LinkHTMLAttributes, ReactNode } from 'react';
import cn from '@/utils/cn';

type TProps = LinkHTMLAttributes<HTMLAnchorElement> & {
  children?: ReactNode;
  className?: string;
  color?: 'primary' | 'secondary' | 'danger' | null;
  dataQaId?: string | null;
  href: string;
  target?: string;
  underline?: boolean;
};

const Link = forwardRef<HTMLAnchorElement, TProps>(
  (
    { children, className, color, dataQaId, href, underline = false, ...props },
    ref
  ) => {
    const combinedClasses = cn(
      {
        'text-primary-green hover:text-primary-greenHover': color === 'primary',
        'text-primary-darkBlue hover:text-primary-darkBlueHover':
          color === 'secondary',
        'text-secondary-red hover:text-secondary-redHover': color === 'danger',
        'underline underline-offset-4': underline,
      },
      className
    );

    return (
      <NextLink
        className={combinedClasses}
        data-qa-id={dataQaId}
        href={href}
        passHref
        ref={ref}
        {...props}
      >
        {children}
      </NextLink>
    );
  }
);

Link.displayName = 'Link';

export default Link;
